var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('line',_vm._b({},'line',{
            class : 'tool_svgElem',
            id  : _vm.tool.id + '-body',
            x1  : _vm.tool.coords.pts[0].x, 
            y1  : _vm.tool.coords.pts[0].y,
            x2  : _vm.tool.coords.pts[1].x,   
            y2  : _vm.tool.coords.pts[1].y,
        },false))])
}
var staticRenderFns = []

export { render, staticRenderFns }